import PropTypes from 'prop-types';
import { action } from 'mobx';
import ValueStore from './ValueStore';

export default class BoolStore extends ValueStore {
    static _PropType = {
        ...ValueStore._PropType,
        toggle: PropTypes.func.isRequired,
        isTrue: PropTypes.func.isRequired,
        isFalse: PropTypes.func.isRequired,
    };

    static PropTypes = PropTypes.shape(BoolStore._PropType);

    toggle = action(() => this.setValue(!this.getValue()));

    isTrue = () => this.equals(true);

    isFalse = () => this.equals(false);
}
